import React from 'react';

export default function Loading() {
    return (
        <div className="Backdrop-root" >
            <div className="MuiCircularProgress-root CircularProgress-indeterminate" >
                <svg className="MuiCircularProgress-svg" viewBox="22 22 44 44">
                    <circle className="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate" cx="44"
                            cy="44" r="20.2" fill="none" strokeWidth="3.6" />
                </svg>
            </div>
        </div>
    )
}
